import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class MyJourneyService {
  api_url = environment.SERVER_URL + 'icrweb/home/'
  constructor(
    private http: HttpClient
  ) { }
  getMyJourneyDetails(request) {
    return this.http.post(this.api_url + 'get_myjourney_status_check', request);
  }

  loadPreofferDetails(request) {
    return this.http.post(this.api_url + 'get_myjourney_pre_offer_doc_details', request);
  }
}
